import { constructionAsset, constructionSafety, logisticsAsset, logisticsSafety, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '오토바이 위치 추적은 위성 신호를 사용하는 글로벌 위치 추적 시스템인 GPS를 활용하여 오토바이의 실시간 위치를 정확하게 파악하는 기술입니다. 위치 추적 장치는 오토바이에 직접 부착하거나 스마트폰 애플리케이션을 통해 통합될 수 있습니다. 이 기술은 오토바이 추적뿐만 아니라 내비게이션, 경로 관리, 오토바이 안전 향상에도 도움을 줍니다.\n작고 컴팩트한 장치 하나로, 혼잡한 주차장이나 낯선 도로에서도 오토바이의 정확한 위치를 파악할 수 있습니다.',
  keywords: '오토바이 추적, GPS, 오토바이 GPS, 오토바이 안전, 오토바이 관리',
  ogSite: '모든 오토바이 운전자가 GPS 추적기 사용을 고려해야 하는 이유',
  title: '모든 오토바이 운전자가 GPS 추적기 사용을 고려해야 하는 이유',
  ogUrl: 'https://orbro.io/blog/motorbikeGPS',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_FkXduib7xnVbWShIdvBsbCjnga1oVZy6DyT2OQN-sBmNvnZchUtttKZ5CSV83mvBASwMHEkW68X5C_uepjuq6ISwuLP0H3iJ2wN0gIkRDxfgff9HPUl2AfBJFGcuVDlemtWJJQ167tf6MngqMr6k1ecQ6Ls5yhkEOi8bJVjTgMMJWX5FoKixJ2P6d2zBbrLnS3-6rqnBOnPn3nIMwewd2R_T14ndheea-qYSmPt_eAM0O3jnB-xbUSaQwN9RJJBNh_1vHXPAn5dvA6OREsyuRYjpDnaY-zgTt101DTEG8qqrnclbDMr_dSoJj6UUohmwxQbXMdCuPrNwtA_CGqhBAJFkbjW2OaZpv_acopEhvKcv2_885m5BVmUYdEQ5ldanX7-GaHQPV32b3AEukPCy1ny2s_a1t1TiPgAvTR4musWfYHDv5866la7VRgVX5mGIunzApDBQtGNsKsjmHTV0njUilVJVxoIS7aLIzqQ01TpbMTnrput22RRyfxAgXV_vVa4DRcwU4mPYNb7arDcs_978eHlIc2bb5a4oM0LUeYhYXCGWklU4B03R1jf6YR5HsOt72WyU9-a4lUUNRkz_Ho82RXniqu93zwpyn5htKmZeljOJ5ToFzBgwzpsbPqJar88gFCygKaq7lbSkf4s9_2KPuqi60WUn6nwTJK6JPV-NwqOe12jaE8_prEnaODIeBfaEHQRMbAz2eaBOnrgcRAVavZ686LOe38A_DLJMMRSyRwfqrmTqC-8egansp3FHOzEDa3DhJl_RCuXWcKa8MhmYd8m7yx4uMqJX01yJVqnl94yH5zo9ILQiFJq34MsBkXrsmjNbltmllMB2hpxqQbfLQjj5ZFrtIms6mf_Xp9fZ2WXlel8XPzcgAacdIgO-eigfwJauo-gTUXTo6M0d2hhpCE6otYM3VEb3d38VnsuFB7SaOPUpDA_QsUdPCLj5jwoVNO75MRwJObK7_DW1WpZbN0R17NsjGLN-I0NYyfDrnSulB7fjrTXDjdy4mwjTL6sbeaj2TLJYYGnk8Ao3LrBzlbIGdVpYG0_eXQqkEquTZ69UJn3EjB_KelomO2l4WggICoA2AgkTKT9EvhTmGQ_v-b0QYJOQKbrxwXi61Ml9q69fv-eTB9tfkzzsJuqbUr0RIkXiS5q1jLQG_mwiPk2lChRcxLNon80sGYTjIs_OmZGPuc--DjGz586TgHZkRbqyU4d_iAX91LZp5zBUkoVAh4tOttBVxdhKyTFoQtoptvIF92DZiYOJgShyUUz-9w8J4_RltIGzbuWmD44BYwp2hlck8iohK5LyIf0n_Rm9ZEKZM_3NEheO5g-yangJKzEbZrmEo6ZQNvKGcpByRQ9tMzfRr2kQMQwoVB19qYmgNy4Ta7k73uOjXWlGMwu9P_oCZXRSLbIOrNLiGtOy28tsBVoBGoys0z2ySIOQT84OVv2FDlJyWN9b1cUtprzsGnk13NpuwlTWQzPVIUz5QmerHplwBta7cxO9PEEF2fFhVAkmhQ_d9cmzLsvjb5zwU48ipVEjVa2Wao0_nj-w55m9EGAVdmhRjX7AAhsmcPir98TsPGxlhBchQVxJ8lEHQWC3JhKcokImEqSuJcbBsOL3VDsVABVkWtXhJ6=w1288-h1414?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-20',
  tag1: '#오토바이추적',
  tag2: '#GPS',
  tag3: '#오토바이GPS',
  tag4: '#오토바이안전 #오토바이관리',
  text: [
    {
      head: '',
      subHead: '',
      desc: '오토바이는 많은 국가에서 널리 사용되는 교통 수단으로, 많은 사람들의 일상에서 편리함과 유연성을 제공하는 필수적인 부분입니다. 그러나 오토바이 사용에는 교통사고, 길 잃음, 도난과 같은 여러 위험이 따릅니다. 이러한 문제를 해결하기 위해 오토바이 위치 추적은 더 안전한 이동을 위한 스마트한 솔루션으로 자리 잡고 있습니다. 이 기술이 점점 더 인기를 얻고 있는 이유를 함께 알아보세요!',
      dot: ''
    },
    {
      head: 'RTLS란 무엇이며 제조 공장에서 어떻게 작동하나?',
      subHead: '',
      desc: '오토바이는 많은 국가에서 널리 사용되는 교통 수단으로, 많은 사람들의 일상에서 편리함과 유연성을 제공하는 필수적인 부분입니다. 그러나 오토바이 사용에는 교통사고, 길 잃음, 도난과 같은 여러 위험이 따릅니다. 이러한 문제를 해결하기 위해 오토바이 위치 추적은 더 안전한 이동을 위한 스마트한 솔루션으로 자리 잡고 있습니다. 이 기술이 점점 더 인기를 얻고 있는 이유를 함께 알아보세요!',
      dot: ''
    },
    {
      head: '오토바이 위치 추적이란?',
      subHead: '',
      desc: '오토바이 위치 추적은 위성 신호를 사용하는 글로벌 위치 추적 시스템인 GPS를 활용하여 오토바이의 실시간 위치를 정확하게 파악하는 기술입니다. 위치 추적 장치는 오토바이에 직접 부착하거나 스마트폰 애플리케이션을 통해 통합될 수 있습니다. 이 기술은 오토바이 추적뿐만 아니라 내비게이션, 경로 관리, 오토바이 안전 향상에도 도움을 줍니다.\n\n작고 컴팩트한 장치 하나로, 혼잡한 주차장이나 낯선 도로에서도 오토바이의 정확한 위치를 파악할 수 있습니다.',
      dot: ''
    },
    {
      head: '오토바이 위치 추적의 실질적인 이점',
      subHead: '',
      desc: '오토바이 GPS 기술은 자산 보호부터 주행 경험 향상에 이르기까지 다양한 실질적인 가치를 제공합니다. 다음은 주요 이점입니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '1. 교통 안전 보장',
      desc: '위험한 도로 회피: 오토바이 위치 추적을 통해 교통 체증, 공사 중인 도로, 사고 위험이 높은 구간에 대한 정보를 받아 더 안전한 경로를 선택할 수 있습니다.\n\n긴급 지원: 사고 발생 시 GPS 시스템은 정확한 위치를 제공하여 가족이나 구조대가 신속하게 도움을 줄 수 있도록 합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '2. 길 찾기의 편리함',
      desc: '정확한 내비게이션: 새로운 장소나 낯선 지역으로 이동할 때 오토바이 위치 추적은 길을 잃지 않도록 도와주며, 시간과 노력을 절약해줍니다.\n\n실시간 교통 업데이트: 많은 GPS 애플리케이션은 교통 정보를 통합하여 교통 체증을 피하고 최적의 경로를 선택할 수 있도록 합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '3. 오토바이 도난 방지',
      desc: '위치 추적: 오토바이가 도난당했을 경우, 오토바이 GPS를 통해 즉시 오토바이의 위치를 파악하고 당국과 협력하여 되찾을 수 있습니다.\n\n스마트 알림: 일부 장치는 오토바이가 비정상적으로 이동할 때 알림을 보내 즉시 대응할 수 있도록 합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '4. 효과적인 오토바이 관리',
      desc: '여정 기록: 오토바이 위치 추적은 이동 기록을 제공하여 개인용 오토바이나 운송 사업에서 유용하게 활용할 수 있습니다.\n\n가족 모니터링: 가족, 특히 어린이나 노인이 오토바이를 사용할 때 오토바이 안전을 보장하기 위해 추적할 수 있습니다.',
      dot: ''
    },
    {
      head: '적합한 오토바이 위치 추적 장치 선택 방법',
      subHead: '',
      desc: '이 기술의 이점을 최대한 활용하려면 필요에 맞는 장치를 선택해야 합니다. 다음은 중요한 기준입니다.\n\n높은 정확도: 도시와 시골 지역 모두에서 잘 작동하는 장치를 선택할 필요가 있습니다.\n\n다양한 기능: 속도 경고, 여정 저장, 스마트폰 연결과 같은 추가 기능을 가진 제품을 선택하는 것이 좋습니다.\n\n사용 편의성: 설치와 운영이 쉬운 사용자 친화적인 인터페이스를 가진 장치를 선택하는 것이 좋습니다.\n\n합리적인 비용: 예산에 따라 무료 애플리케이션으로 시작하거나 전문 장치에 투자할 수 있습니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: '기술이 발전하는 시대에 오토바이 위치 추적은 단순한 지원 장치가 아니라 오토바이 운전자들에게 모든 여정에서 더 큰 안심을 제공하는 종합적인 솔루션입니다. 오토바이 안전 향상, 길 찾기 지원, 효과적인 오토바이 관리에 이르기까지 GPS 기술은 부인할 수 없는 가치를 제공합니다.\n\n지금 바로 오토바이 GPS를 사용해 자신과 가족, 그리고 자산을 보호하세요. 작은 결정이 매 여정에서 큰 차이를 만들 수 있습니다!',
      dot: ''
    }
  ],

    link: {
      page: 'rtls',
      numb: '1',
      product: [
        {
          text: productPurchase.purchase.ble.bleStarterKit.title,
          title: productPurchase.purchase.ble.bleStarterKit.title,
          serial: productPurchase.purchase.ble.bleStarterKit.serial,
          desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
          img: productImg.product.bleStarterKit.key1,
        },
        {},
      ],
      solution: [
        {
          img: constructionSafety.thumb,
          data: 'constructionSafety',
          link: '/enterprise/construction/safety',
        },
        {
          img: logisticsSafety.thumb,
          data: 'logisticsSafety',
          link: '/enterprise/logistics/safety',
        },
        {
          img: manufacturingSteel.thumb,
          data: 'manufacturingSteel',
          link: '/enterprise/manufacturing/steel',
        },
      ],
    },
  };
  